import { ThemeSemantic } from "shared/theme/themeSemantic";
import { css } from "styled-components";

/* Spacing between Severity Icon og summary/title */
export const COLUMN_GAP = 6;

/* Border radius of the info message components */
export const BORDER_RADIUS = 6;

export const InfoMessageBaseStyling = (
  theme: ThemeSemantic,
  borderColorOverride?: string,
  backgroundColorOverride?: string,
  titleColorOverride?: string,
) => css`
  padding: 9px;
  border-radius: ${BORDER_RADIUS}px;
  border: 1px solid ${borderColorOverride ?? theme.colorSemanticOutline};
  background-color: ${backgroundColorOverride ?? theme.colorSemanticFillPulse};
  color: ${titleColorOverride ?? theme.colorSemanticTextMain};
`;
